export const INIT = 'merchant/init';
export const LIKE = 'merchant/like';
export const DISLIKE = 'merchant/dislike';
export const LOADING = 'merchant/loading';

const initialState = {
  // public_id: {
  //   liked: bool
  // }
};

// tslint:disable-next-line: no-any
export default (state = initialState, action: any) => {
  switch (action.type) {
    case INIT: {
      const { publicId, liked, favoriteCount } = action.payload;
      return {
        ...state,
        loading: false,
        [publicId]: { ...state[publicId], liked, favoriteCount },
      };
    }
    case LIKE: {
      const { publicId } = action.payload;
      const favoriteCount = state[publicId].favoriteCount + 1;
      return {
        ...state,
        loading: false,
        [publicId]: { ...state[publicId], liked: true, favoriteCount },
      };
    }
    case DISLIKE: {
      const { publicId } = action.payload;
      const favoriteCount = state[publicId].favoriteCount - 1;
      return {
        ...state,
        loading: false,
        [publicId]: { ...state[publicId], liked: false, favoriteCount },
      };
    }
    case LOADING: {
      return {
        ...state,
        loading: true,
      };
    }
    default:
      return state;
  }
};
